/** "Assign to" dropdowns (`Select`/`Menu`, `@orion/ui`) only have a plain
 * string `label` — no secondary-text slot — so when two active members
 * share a display name, the only way to tell them apart in the list is to
 * fold the distinguisher into that string. Returns a label per member,
 * appending `(email)` only for the names that actually collide in the
 * given list — everyone else keeps a plain name, so a workspace with no
 * duplicates never shows an email in a picker meant to show names. */
export function disambiguateNames<T extends { id: string; displayName: string; email?: string | null }>(members: readonly T[]): Map<string, string> {
  const counts = new Map<string, number>();
  for (const m of members) counts.set(m.displayName, (counts.get(m.displayName) ?? 0) + 1);

  const labels = new Map<string, string>();
  for (const m of members) {
    const isDuplicate = (counts.get(m.displayName) ?? 0) > 1;
    labels.set(m.id, isDuplicate && m.email ? `${m.displayName} (${m.email})` : m.displayName);
  }
  return labels;
}
